var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PropTypes from 'prop-types';
import { ImagePropTypes } from '../components/LazyImage';
export var Modifiers;
(function (Modifiers) {
    Modifiers["FontBold"] = "font-weight.bold";
    Modifiers["FontOblique"] = "font-style.oblique";
    Modifiers["FontItalic"] = "font-style.italic";
    Modifiers["ColorBrand"] = "color.brand";
    Modifiers["ColorSale"] = "color.sale";
})(Modifiers || (Modifiers = {}));
export var ItemShape = {
    /** Navigation item display name. */
    name: PropTypes.string,
    /** Link to redirect, only if navigation item is a leaf */
    href: PropTypes.string,
    /** Custom HTML to display in navigation item. */
    html: PropTypes.string,
    /** Navigation item display image (replaces name). */
    image: PropTypes.string,
    /** Optional promo image at level2 item */
    promoImg: PropTypes.shape(__assign(__assign({}, ImagePropTypes), { alt: PropTypes.string, href: PropTypes.string })),
    /** Optional link modifiers for customizing navigation item styles. */
    modifiers: PropTypes.arrayOf(PropTypes.oneOf([
        Modifiers.FontBold,
        Modifiers.FontOblique,
        Modifiers.FontItalic,
        Modifiers.ColorBrand,
        Modifiers.ColorSale,
    ])),
    children: PropTypes.any,
};
/**
 * Children navigation items list.
 * If navigation item is a leaf this prop should be an empty array.
 */
ItemShape.children = PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape(ItemShape)),
    PropTypes.object,
]));
export var ItemPropType = PropTypes.shape(ItemShape);
